import { http } from '../../core/services/http';
import transformLoadWasteTypes from './transformLoadWasteTypes';

const loadWasteTypes = () => http.get('services/wasteTypes').then(response => transformLoadWasteTypes(response.data));

export default loadWasteTypes;
